import React from "react";
import { Stack } from "@mui/material";
import { SlideBlockView } from "./SlideBlockView";
import type { ReportBlock } from "../api/types";
import type { ReportBranding } from "../utils/branding";

interface ReportPageViewProps {
  blocks: ReportBlock[];
  clientId: string | null;
  branding?: ReportBranding;
  /** print = static layout for PDF/PPTX; screen = presentation slide. */
  variant?: "screen" | "print";
}

/**
 * Read-only render of one report page's blocks, via the shared SlideBlockView
 * dispatcher. Used by presentation mode and the print route so the exported
 * pack matches what's presented on screen.
 */
export const ReportPageView: React.FC<ReportPageViewProps> = ({
  blocks,
  clientId,
  branding,
  variant = "screen",
}) => {
  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      {blocks.map((block) => (
        <SlideBlockView
          key={block.id}
          block={block}
          clientId={clientId}
          branding={branding}
          fill={variant === "screen"}
        />
      ))}
    </Stack>
  );
};
